var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCalendarGraphics = function SvgIconCalendarGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5665"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1974",
    fill: "#fff",
    opacity: 0.8,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 553"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2227",
    d: "M32.034 5.37a1.082 1.082 0 0 1 1.08 1.08v2.126h6.271a4.251 4.251 0 0 1 4.246 4.247v27.565a4.247 4.247 0 0 1-4.243 4.243H10.61a4.245 4.245 0 0 1-4.243-4.239v-27.57a4.251 4.251 0 0 1 4.247-4.246h6.271V6.451a1.08 1.08 0 0 1 1.08-1.081 1.081 1.081 0 0 1 1.081 1.081v2.125h11.906V6.451a1.082 1.082 0 0 1 1.082-1.08m0 8.576a1.082 1.082 0 0 1-1.081-1.08V10.74H19.046v2.13a1.08 1.08 0 0 1-1.081 1.081 1.079 1.079 0 0 1-1.08-1.08V10.74h-6.271a2.087 2.087 0 0 0-2.086 2.086V16.2h32.938v-3.378a2.087 2.087 0 0 0-2.085-2.086H33.11v2.126a1.075 1.075 0 0 1-1.064 1.089h-.009M10.61 42.47h28.775a2.083 2.083 0 0 0 2.081-2.078V18.361H8.528v22.031a2.084 2.084 0 0 0 2.082 2.078",
    fill: "#4b4b4b"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2228",
    d: "M14.246 29.21a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.207 1.206 1.206 0 0 1-1.207-1.207 1.208 1.208 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2229",
    d: "M14.246 36.378a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.207 1.206 1.206 0 0 1-1.207-1.207 1.206 1.206 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2238",
    d: "M28.582 22.039a1.207 1.207 0 0 1 1.208 1.207 1.207 1.207 0 0 1-1.208 1.205 1.206 1.206 0 0 1-1.207-1.207 1.209 1.209 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2239",
    d: "M28.582 29.21a1.207 1.207 0 0 1 1.208 1.207 1.207 1.207 0 0 1-1.208 1.207 1.206 1.206 0 0 1-1.207-1.207 1.209 1.209 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2240",
    d: "M28.582 36.378a1.207 1.207 0 0 1 1.208 1.207 1.207 1.207 0 0 1-1.208 1.207 1.206 1.206 0 0 1-1.207-1.207 1.208 1.208 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2242",
    d: "M21.416 22.039a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.205 1.207 1.207 0 0 1-1.208-1.207 1.209 1.209 0 0 1 1.208-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2243",
    d: "M21.416 29.21a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.207 1.207 1.207 0 0 1-1.208-1.207 1.209 1.209 0 0 1 1.208-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2244",
    d: "M21.416 36.378a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.207 1.207 1.207 0 0 1-1.208-1.207 1.208 1.208 0 0 1 1.208-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2246",
    d: "M35.753 22.039a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.205 1.206 1.206 0 0 1-1.207-1.205 1.209 1.209 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2247",
    d: "M35.753 29.21a1.206 1.206 0 0 1 1.207 1.207 1.206 1.206 0 0 1-1.207 1.207 1.206 1.206 0 0 1-1.207-1.207 1.209 1.209 0 0 1 1.207-1.207",
    fill: "#4b4b4b"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendarGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar-graphics.853633f6.svg";
export { ForwardRef as ReactComponent };